import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const datasetEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('datasetEntitlementsState', undefined);

export const datasetEntitlementsStateActions = datasetEntitlementsStateSlice.actions;
export const datasetEntitlementsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementsFilters
> = state => state.manageEntitlements.datasetEntitlementsReducer.state;
